import styled from 'styled-components'

export const InputContainer = styled.div`
  position: relative;
`

export const Step2List = styled.ul`
      padding-left: 0px;
`
